import { Center } from "@chakra-ui/react";
import { ModalNew as Modal } from "components/Modal/ModalNew";
import { ProjectDetailCard } from "components/ProjectCard/ProjectDetailCard";
import { KeyPersonnelProject } from "types/key-personnel.types";
import { useQuery } from "@tanstack/react-query";
import { getPastProjectById } from "actions/RFQ/Supplier/rfqActions";
import { PastProject } from "types/past-project.types";
import ProjectCardSkeleton from "../../../components/RFQ/ProjectCard/ProjectCardSkeleton";

type ProjectDetailModalProps = {
	isOpen: boolean;
	project: KeyPersonnelProject;
	onClose: () => void;
};

export const ProjectDetailModal = ({
	isOpen,
	onClose,
	project,
}: ProjectDetailModalProps) => {
	const { data: pastProject, isLoading } = useQuery({
		queryKey: ["pastProject", project.project_id],
		queryFn: getPastProjectById,
		enabled: !!project.project_id && isOpen,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			padding={false}
			width="600px"
			maxWidth="80vw"
		>
			{isLoading ? (
				<ProjectCardSkeleton />
			) : pastProject ? (
				<ProjectDetailCard data={pastProject as PastProject} />
			) : (
				<Center py={10}>Project details not available</Center>
			)}
		</Modal>
	);
};
